import { TCacheState, TCacheAction } from "./cache.state";
import { SEARCH_TABS } from "~/types/search.types";
import { SearchActions } from "~/types/actions.enum";

// ✅ Disclosure reducer logic
export const cacheReducer = (state: TCacheState, action: TCacheAction): TCacheState => {
    switch (action.type) {
        case SearchActions.SET_CACHE_CATEGORIES: {
            const { type } = action.payload;

            return {
                ...state,
                ...(type === SEARCH_TABS.IMAGES && {
                    graphicsCategories: [...action.payload.data]
                }),
                ...(type === SEARCH_TABS.REPORTS && { reportsCategories: [...action.payload.data] })
            };
        }

        case SearchActions.SET_CACHE_TOPICS: {
            const { type } = action.payload;

            return {
                ...state,
                ...(type === SEARCH_TABS.IMAGES && { graphicsTopics: [...action.payload.data] }),
                ...(type === SEARCH_TABS.REPORTS && { reportsTopics: [...action.payload.data] })
            };
        }

        default:
            return state;
    }
};
